import axios from 'axios';
import apiroutes from '@/API/ApiRoutes';


const state = {
  data : JSON.parse(localStorage.getItem('dashboardData')) != null ? JSON.parse(localStorage.getItem('dashboardData')).data : '',
  hasProfile : JSON.parse(localStorage.getItem('dashboardData')) != null ? JSON.parse(localStorage.getItem('dashboardData')).hasProfile : ''
};
const getters = {
  getDataFromDashboardLayout(){
    return {data: state.data, hasProfile: state.hasProfile};
  }
};
const actions = {

};
const mutations = {
  setDataFromDashboardLayout(state,payload){
    state.data = payload.data;
    state.hasProfile = payload.hasProfile;
    localStorage.setItem('dashboardData', JSON.stringify({data: state.data, hasProfile: state.hasProfile}));
  }
};

export default {
  getters,
  state,
  actions,
  mutations
};
